// extracted by mini-css-extract-plugin
export default {"record-label":"campaignTable_record-label__gRdZP","menu-items":"campaignTable_menu-items__38Ga0","progress":"campaignTable_progress__0HmWK","button":"campaignTable_button__Y5yuS"};